import { Navigate, Route, Routes } from "react-router-dom";
import AppShell from "./components/AppShell";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import CollectionsPage from "./pages/CollectionsPage";
import BlacklistPage from "./pages/BlacklistPage";
import ReportsPage from "./pages/ReportsPage";
import TeamPage from "./pages/TeamPage";
import CustomersPage from "./pages/CustomersPage";
import MonthlyLoansPage from "./pages/MonthlyLoansPage";
import LoanLedgerPage from "./pages/LoanLedgerPage";
import CustomerRecordPage from "./pages/CustomerRecordPage";

const ProtectedRoute = ({ children, onSignOut, user }) => {
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return <AppShell user={user} onSignOut={onSignOut}>{children}</AppShell>;
};

const CompanyManagerRoute = ({ children, onSignOut, user }) => {
  if (!["admin", "master"].includes(user?.role)) {
    return <Navigate to="/customers" replace />;
  }
  return <ProtectedRoute user={user} onSignOut={onSignOut}>{children}</ProtectedRoute>;
};

const protectedPage = (page, user, onSignOut) => (
  <ProtectedRoute user={user} onSignOut={onSignOut}>{page}</ProtectedRoute>
);

export const AppRoutes = ({ onLogin, onSignOut, user }) => {
  return (
    <Routes>
      <Route
        path="/login"
        element={user ? <Navigate to="/" replace /> : <LoginPage onLogin={onLogin} />}
      />
      <Route path="/" element={protectedPage(<DashboardPage user={user} />, user, onSignOut)} />
      <Route
        path="/customers"
        element={protectedPage(<CustomersPage user={user} />, user, onSignOut)}
      />
      <Route
        path="/customer-record/:customerId"
        element={protectedPage(<CustomerRecordPage user={user} />, user, onSignOut)}
      />
      <Route
        path="/loan-ledger/:loanId"
        element={protectedPage(<LoanLedgerPage />, user, onSignOut)}
      />
      <Route
        path="/new-loans"
        element={protectedPage(<MonthlyLoansPage user={user} />, user, onSignOut)}
      />
      <Route path="/loans" element={<Navigate to="/new-loans" replace />} />
      <Route
        path="/collections"
        element={protectedPage(<CollectionsPage />, user, onSignOut)}
      />
      <Route
        path="/blacklist"
        element={protectedPage(<BlacklistPage />, user, onSignOut)}
      />
      <Route path="/reports" element={protectedPage(<ReportsPage />, user, onSignOut)} />
      <Route
        path="/team"
        element={(
          <CompanyManagerRoute user={user} onSignOut={onSignOut}>
            <TeamPage user={user} />
          </CompanyManagerRoute>
        )}
      />
      <Route path="/payments" element={<Navigate to="/new-loans" replace />} />
      <Route path="/settings" element={<Navigate to="/customers" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};